import Properties from './properties.vue';
import PropertiesForm from './properties-form.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

var routes = [
    {
        path: '/properties/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('properties', ['ADMIN'], Properties),
        keepAlive: true
    },
    {
        path: '/properties/new/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('properties/new', ['ADMIN'], PropertiesForm)
    },
    {
        path: '/properties/edit/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('properties/edit', ['ADMIN'], PropertiesForm)
    },
    {
        path: '/properties/view/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('properties/view', ['ADMIN'], PropertiesForm, { editable: false })
    }
];

export default routes;
